export const INIT_LOADING_FORMAT = "INIT_LOADING_FORMAT"
export const END_LOADING_FORMAT = "END_LOADING_FORMAT"
export const ERROR = "ERROR"
export const GET_FORMAT_LIST = "GET_FORMAT_LIST"
export const GET_TEMPLATE_TYPE_LIST = "GET_TEMPLATE_TYPE_LIST"
export const INIT_LOADING_TYPES = "INIT_LOADING_TYPES"
export const END_LOADING_TYPES = "END_LOADING_TYPES"